import './PermissionDenied.scss';

export { default } from './PermissionDenied';
